module.exports = __webpack_public_path__ + "static/media/onhold_white.19c0ad9b.svg";